import { render, staticRenderFns } from "./LogsComponent.vue?vue&type=template&id=543df2f6&scoped=true"
import script from "./LogsComponent.vue?vue&type=script&lang=js"
export * from "./LogsComponent.vue?vue&type=script&lang=js"
import style0 from "./LogsComponent.vue?vue&type=style&index=0&id=543df2f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543df2f6",
  null
  
)

export default component.exports